import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Input, Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import SvgFormat from 'common/helpers/svgFormat';
import TableColumnSearch from '~components/table-column-search';
import CurrencyBar from '~components/currency-bar';
import SelectPropertyInfo from 'common/components/property-type-select';

@withTranslation()
class BasicInformation extends React.Component {
  constructor() {
    super();

    this.autoInputValue = {
      cityValue: '',
      landlordValue: '',
    };

    this.state = {};
  }

  componentDidMount() {
    if (this.props.basicInfo && Object.keys(this.props.basicInfo).length > 1) {
      this.props.form.setFieldsValue({
        type: this.props.basicInfo.type,
        name: this.props.basicInfo.name,
        city: this.props.basicInfo.city.slug,
      });
    }
  }

  handleSearch = (slug, value) => {
    this.props.form.setFieldsValue({
      city: slug || '',
    });
    this.props.setPropertyData(
      'basicInfo',
      {
        city: value,
      },
      true,
    );
  };

  changeCurrencyState = (state, data) => {
    this.props.setCountryData(state, data);
    this.props.setPropertyData('basicInfo', {
      countryData: data,
    });
  };

  resetValue = searchType => {
    if (searchType === 'city') {
      this.props.form.resetFields(['city']);
    }
  };

  saveSearchValue = (value, searchType) => {
    this.props.changeLeaveAlert();
    if (searchType === 'city') {
      this.autoInputValue.cityValue = value;
    } else {
      this.autoInputValue.landlordValue = value;
    }
  };

  typeSelect = (type, propertyTypeData) => {
    let index = propertyTypeData.findIndex(property => property?.slug === type);
    const apartmentName = propertyTypeData[index]?.name;
    this.props.handleApartmentType(type, apartmentName);
    this.props.changeLeaveAlert();
  };

  render() {
    const { t, basicInfo, countryData } = this.props;
    const { getFieldDecorator, getFieldValue } = this.props.form;

    return (
      <div className={'basic-info'}>
        <Form className="basic-info__form">
          <Form.Item>
            <span className="basic-info__label">
              {t('cms:before_start_tell_us_what_is_your_apartment_type')}
            </span>
            {getFieldDecorator('type', {
              rules: [
                {
                  required: true,
                  message: t('cms:select_your_apartment_type'),
                },
              ],
              validateTrigger: 'onBlur',
            })(<SelectPropertyInfo onChange={this.typeSelect} />)}
          </Form.Item>
          <Form.Item>
            <span className="basic-info__label">
              {t('cms:cms.properties.create.basic_information.apartment_name_label')}
            </span>
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: t('cms:cms.properties.edit.error.blank'),
                },
                {
                  validator: (rule, value, callback) => {
                    const emojiRegex = new RegExp(
                      /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
                    );
                    if (value && emojiRegex.test(value)) {
                      callback('error');
                    }
                    callback();
                  },
                  message: t('cms:cms.properties.create.create_confirmation.error_emoji'),
                },
                {
                  validator: (rule, value, callback) => {
                    if (value && value.length > 250) {
                      callback('error');
                    }
                    callback();
                  },
                  message: t('cms:cms.properties.create.create_confirmation.error_length'),
                },
              ],
              validateTrigger: 'onBlur',
            })(
              <Input
                placeholder={t(
                  'cms:cms.properties.create.basic_information.apartment_name_placeholder',
                )}
                onChange={this.props.changeLeaveAlert}
              />,
            )}
          </Form.Item>
          <Form.Item>
            <div
              className="basic-info__city"
              ref={node => {
                this.basicInfoCity = node;
              }}
            >
              <span className="basic-info__label">
                {t('cms:cms.properties.create.basic_information.apartment_city_label')}
                <Tooltip
                  title={t('cms:cms.properties.create.basic_information.apartment_city_tooltip')}
                  placement="right"
                >
                  <ExclamationCircleOutlined className="basic-info__circle" />
                </Tooltip>
              </span>
              {getFieldDecorator('city', {
                rules: [
                  {
                    validator: (rule, value, callback) => {
                      if (this.autoInputValue.cityValue && !getFieldValue('city')) {
                        callback('error');
                      }
                      callback();
                    },
                    message: t(
                      'cms:cms.properties.create.basic_information.apartment_city_invalid',
                    ),
                  },
                  {
                    validator: (rule, value, callback) => {
                      if (!getFieldValue('city')) {
                        callback('error');
                      }
                      callback();
                    },
                    message: t('cms:cms.properties.edit.error.blank'),
                  },
                ],
                trigger: 'onChange',
              })(
                <TableColumnSearch
                  searchType="city"
                  isLocaitonCustom
                  showCountry
                  onSearch={(slug, value, type) => {
                    this.handleSearch(slug, value, type);
                  }}
                  t={t}
                  changeCurrencyState={this.changeCurrencyState}
                  placeholder={t(
                    'cms:cms.properties.create.basic_information.apartment_city_placeholder',
                  )}
                  basicType="basicCity"
                  valueData={
                    basicInfo.city ? `${basicInfo.city.name}, ${basicInfo.city.countryName}` : ''
                  }
                  resetValue={this.resetValue}
                  saveSearchValue={this.saveSearchValue}
                  parrentNode={this.basicInfoCity}
                />,
              )}
              <CurrencyBar t={t} countryData={countryData.data ? countryData.data : null} />
            </div>
          </Form.Item>
        </Form>
        <If condition={false}>
          <div className="basic-info__tips">
            <div className="basic-info__tips-title">
              <SvgFormat className="basic-info__tips-icon" type="create-tips" />
              <span className="basic-info__tips-text">
                {t('cms:cms.properties.create.basic_information.apartment_tips_title')}
              </span>
            </div>
            <div className="basic-info__tips-content">
              {t('cms:cms.properties.create.basic_information.apartment_tips_content')}
            </div>
          </div>
        </If>
      </div>
    );
  }
}

BasicInformation.propTypes = {
  t: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  handleApartmentType: PropTypes.func.isRequired,
  basicInfo: PropTypes.object.isRequired,
  setPropertyData: PropTypes.func.isRequired,
  setCountryData: PropTypes.func.isRequired,
  countryData: PropTypes.object.isRequired,
  propertyType: PropTypes.array.isRequired,
  changeLeaveAlert: PropTypes.func.isRequired,
};

BasicInformation.defaultProps = {
  t: () => {},
};

const BasicInformationForm = Form.create({
  name: 'basic_information_form',
  onFieldsChange: (props, changedFields) => {
    Object.keys(changedFields).map(key => {
      if (!changedFields[key].errors) {
        if (
          key === 'name' &&
          props.basicInfo &&
          props.basicInfo.name !== changedFields[key].value
        ) {
          props.setPropertyData(
            'basicInfo',
            {
              [key]: changedFields[key].value,
            },
            true,
          );
        }
      }
      return true;
    });
  },
})(BasicInformation);

export default BasicInformationForm;
